import Vue from "vue";
import VueI18n from "vue-i18n";

import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";

Vue.use(VueI18n);

function extendsObj(_target, paths, data) {
    let target = _target;
    const list = [...paths];
    do {
        const key = list.shift();
        if (!key) {
            debugger;
        }
        if (list.length) {
            target[key] = target[key] || {};
        } else {
            target[key] = { ...target[key], ...data };
            break;
        }
        // eslint-disable-next-line no-constant-condition
    } while (true);
}

function loadLocaleMessages() {
    const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {
        en: { ...enLocale },
        cn: { ...zhLocale }
    };
    locales.keys().forEach(key => {
        const matched = key.match(/([^/]+).json$/);
        if (matched) {
            extendsObj(messages, matched[1].split("."), locales(key));
        }
    });
    return messages;
}

const localKey = "locale";
function load() {
    return localStorage.getItem(localKey);
}

export function save(value) {
    localStorage.setItem(localKey, value);
}

export default new VueI18n({
    locale: load() || process.env.VUE_APP_I18N_LOCALE || "en",
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
    messages: loadLocaleMessages()
});
